export const SWITCH_PLATFORM = "SWITCH_PLATFORM";
export const SWITCH_PLATFORM_SUCCESS = "SWITCH_PLATFORM_SUCCESS";
export const SWITCH_PLATFORM_ERROR = "SWITCH_PLATFORM_ERROR";

export const UPDATE_CREDIT_USERTYPE = "UPDATE_CREDIT_USERTYPE";
export const UPDATE_CREDIT_USERTYPE_SUCCESS = "UPDATE_CREDIT_USERTYPE_SUCCESS";
export const UPDATE_CREDIT_USERTYPE_ERROR = "UPDATE_CREDIT_USERTYPE_ERROR";